import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

if (process.env.REACT_APP_API_URL?.includes('-test')) {
  console.log('%c🧪 ŚRODOWISKO TESTOWE (STAGING)', 'background: #ff6600; color: white; font-size: 16px; padding: 4px 8px; border-radius: 4px;');
}

Sentry.init({
  dsn: "https://ac1475ea81c648c68e59630a92a9d174@sentry.etd24.pl/115",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.1,
});

ReactDOM.render(
  <App />,

  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
